import { render, staticRenderFns } from "./stats-users-by-roles.vue?vue&type=template&id=7d4f0132&scoped=true&"
import script from "./stats-users-by-roles.vue?vue&type=script&lang=js&"
export * from "./stats-users-by-roles.vue?vue&type=script&lang=js&"
import style0 from "./stats-users-by-roles.vue?vue&type=style&index=0&id=7d4f0132&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4f0132",
  null
  
)

export default component.exports